/*! bxs-vue-ui v4.0.1 */
import { i as indexOf } from '../utils/es.array.join.js';
import { c as create, n as normalizeComponent } from '../utils/normalize-component.js';
import '../utils/index.js';
import '../utils/object-create.js';
import '../utils/html.js';
import '../utils/es.number.constructor.js';
import 'vue';
import '../utils/extends.js';
import { P as Popup } from '../utils/index2.js';
import '../utils/filter.js';
import '../utils/some.js';
import '../utils/concat.js';
import '../utils/env.js';
import '../safe-area-patch/index.js';

var onlyValues = function onlyValues(values) {
  return function (str) {
    return indexOf(values).call(values, str) !== -1;
  };
};

var script = create({
  name: 'popup',
  mixins: [Popup],
  props: {
    position: {
      type: String,
      default: 'middle',
      validator: onlyValues(['top', 'left', 'bottom', 'right', 'middle'])
    },
    transition: String
  },
  computed: {
    currentTransition: function currentTransition() {
      var transitionName = this.transition;

      if (!transitionName) {
        transitionName = this.position === 'middle' ? 'bx-animate-fade' : "bx-popup-slide--" + this.position;
      }

      return transitionName;
    },
    currentClass: function currentClass() {
      return "bx-popup--" + this.position;
    }
  }
});

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('transition', {
    attrs: {
      "name": _vm.currentTransition
    }
  }, [_vm.value ? _c('div', {
    staticClass: "bx-popup",
    class: _vm.currentClass
  }, [_vm._t("default")], 2) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ =
/*#__PURE__*/
normalizeComponent({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);

export default __vue_component__;
